import { mapState, mapActions } from 'vuex';

export default  {
  data() {
    return {
      stockCode: '',
      allQuery: {},
    }
  },


  computed: {
    ...mapState('stock', [
      'currentStock'
    ])
  },


  methods: {
    ...mapActions('stock', [
      'setCurrentStock' 
    ])
  },


  created() {
    if(this.$route) {
      this.allQuery = this.$route.query;
      
      if(this.allQuery.hasOwnProperty('stockCode') && this.allQuery.stockCode !== "") {
        this.stockCode = this.allQuery.stockCode;
        this.setCurrentStock(this.allQuery.stockCode);
      } else {
        if(this.currentStock) {
          this.stockCode = this.currentStock;
        } else {
          this.stockCode = '';  
        }
      }
    }
  },

  beforeRouteUpdate(to, from, next) {
    if(to.query.hasOwnProperty('stockCode')) {
      this.stockCode = to.query.stockCode;
      this.setCurrentStock(to.query.stockCode);
    } else {
      if(this.currentStock) {
        this.stockCode = this.currentStock;
      } else {
        this.stockCode = '';  
      }
    }

    next();
  }  
}